//这个文件对api进行统一管理
import requests from "./request";

import { apiUrl, baseURL, grade, resourceEnv } from "../api/apiUrl";

//登录的接口  http://192.168.1.72:8080/login
export const fn_loginDate = dateForm => {
  return requests({
    url: "http://192.168.1.122:8080/login",
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(dateForm)
  });
};

export const getGrade = (status, schoolId) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.yearGet}?status=${status}&schoolId=${schoolId}`,
    method: "get"
  });
};

export const selectSchool = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.organizationPut}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//删除用户
export const userDelete = id => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.userDelete}${id}`,
    method: "delete"
  });
};

//查询申请岗位的学生
export const getList = (id, grade, classIds, num) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.applyGetStudent}${id}/${grade}/${num}?queryContent=&classIds=${classIds}`,
    method: "get"
  });
};

//获取学生申请的岗位信息
export const getstation = id => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.StudentGetapply}?ids=${id}`,
    method: "get"
  });
};

//获取学校的实习计划
export const planGet = (id, grade, organization, page, total, name, userId) => {
  // console.log("userId",userId)
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.schoolInternshipGet}${id}/${grade}?name=${name}&page=${page}&total=${total}&teacher=${userId}&organization=${organization}`,
    method: "get"
  });
};

//获取该学校所有班
export const classGet = (
  id,
  grade,
  teacherId,
  organization,
  page,
  total,
  queryContent,
  name,
  type
) => {
  var isid = teacherId ? teacherId : "";
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.classPut}/${id}?queryContent=${queryContent}&grade=${grade}&page=${page}&total=${total}&teacher=${isid}&organization=${organization}&name=${name}&classType=${type}`,
    method: "get"
  });
};

//获取该学校的组织结构
export const organizationGet = (id, grade) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.organizationGet}${id}/${grade}`,
    method: "get"
  });
};

//新增实习计划
export const addinternship = obj => {
  console.log("objobj", obj);
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.internshipPost}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

// 获取该校所有企业
export const getbusiness = (id, grade, page, total, queryContent) => {
  console.log("传的东西", page, total);
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.enterpriseGet}${id}/${grade}?type=&city=&num=&name=&page=${page}&total=${total}&queryContent=${queryContent}`,
    method: "get"
  });
};

//获取实习计划的关联班级
export const getInternshipClass = arr => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.internshipClassPost}?${arr}`,
    method: "get"
  });
};



//删除角色
export const colesDelete = obj => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.rolesDelete}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//新增用户
export const userPudate = obj => {
  console.log("调用新增");
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.userPost}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//修改用户
export const userSet = (obj, isupdate) => {
  console.log("调用修改");

  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.userPost}?isupdate=${isupdate}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//修改用户的状态
export const upUserState = obj => {
  console.log("获取到的OBJ", obj);
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.upUserState}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//添加企业
export const addEnterprise = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.enterprisePost}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//删除企业
export const enterpriseDelete = obj => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.enterpriseDelete}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//新增职位
export const positionAdd = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.positionPost}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//获取公司岗位
export const GetPosition = (id, grade) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.positionGet}${id}`,
    method: "get"
  });
};

//删除岗位
export const feletePosition = id => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.positionDelete}${id}`,
    headers: { "Content-Type": "application/json" }
  });
};

//查询实习小组
export const groupGet = (id, grade, teacherId, page, total, queryContent) => {
  var str = "";
  if (typeof queryContent != "undefined") {
    str = queryContent;
  }
  var organization = "";
  if (JSON.parse(localStorage.getItem("USERDATA")).type == "3") {
    organization = JSON.parse(localStorage.getItem("USERDATA")).organization;
  }
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.groupInternshipGet}${id}/${grade}?queryContent=${str}&teacher=${teacherId}&organization=${organization}&page=${page}&total=${total}`,
    method: "get"
  });
};

//获取用户
export const userGet = (id, grade, page, total, queryContent, phone, jobid) => {
  var searchText = "";
  if (typeof queryContent != "undefined") {
    searchText = queryContent;
  }
  var organization = "";
  if (JSON.parse(localStorage.getItem("USERDATA")).type == "3") {
    organization = JSON.parse(localStorage.getItem("USERDATA")).organization;
    var userid = JSON.parse(localStorage.getItem("USERDATA"))._id;
    var job_id = JSON.parse(localStorage.getItem("USERDATA")).job_id;
    if (
      JSON.parse(localStorage.getItem("USERDATA")).roles[0].name.includes(
        "管理员"
      )
    ) {
      return requests({
        url: `${baseURL}/${resourceEnv}/${apiUrl.userGet}${id}/${grade}?queryContent=${searchText}&username=&page=${page}&total=${total}&organization=${organization}&userid=${userid}&phone=${phone}&jobid=`,
        method: "get"
      });
    }
    //if (organization.split("——").length == 3) {
    return requests({
      url: `${baseURL}/${resourceEnv}/${apiUrl.userGet}${id}/${grade}?queryContent=${searchText}&username=&page=${page}&total=${total}&organization=${organization}&userid=${userid}&phone=${phone}&jobid=${job_id}`,
      method: "get"
    });
    //}
  }
  var userid = "";
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.userGet}${id}/${grade}?queryContent=${searchText}&username=&page=${page}&total=${total}&organization=${organization}&userid=${userid}&phone=${phone}&jobid=${jobid}`,
    method: "get"
  });
};

//新增实习小组
export const addGroup = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.groupInternshipPost}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//查询可添加的学生
export const searchAddSthdentGet = (planId, teacherId) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.addSthdentGet}${planId}?teacher=${teacherId}&queryContent=`,
    method: "get"
  });
};

//添加学生到实习小组
export const AddSthdentGroup = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.addSthdentPost}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//查看实习小组中的学生
export const getGroupStudent = id => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.groupInternshipStudentGet}${id}?&queryContent=`,
    method: "get"
  });
};

//删除实习小组中的学生
export const deleteGroupStudent = obj => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.groupInternshipStudentDelete}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//删除实习小组
export const deleteGroup = obj => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.groupDelete}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//获取手机验证码 userCodeGet
export const getUserCode = phone => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.userCodeGet}${phone}`,
    method: "get"
  });
};

//判断验证码
export const judgeCode = (phone, code) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.userCodeGet}?phone=${phone}&code=${code}`,
    method: "get"
  });
};

//手机验证码登录 verificationLogin
export const userLogin = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.verificationLogin}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//isStayPhoneGet
export const isStayPhone = phone => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.isStayPhoneGet}${phone}`,
    method: "get"
  });
};

//修改申请状态
export const changeApply = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.applyGetState}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//获取老师下管理的实习计划
export const planTeacherGet = (id, grade, teacherId) => {
  return requests({
    url: `${
      apiUrl.schoolInternshipGet
    }${id}/${grade}?name=&page=1&total=1000&teacher=${teacherId}&organization=${
      JSON.parse(localStorage.getItem("USERDATA")).organization
    }`,
    method: "get"
  });
};

//获取实习计划周数
export const planWeeNumberkGet = id => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.planWeek}${id}?type=pc`,
    method: "get"
  });
};

//获取日报和周报
export const planDateDayGet = (
  id,
  date,
  teacherId,
  type,
  end,
  schoolId,
  grade,
  groupId,
  page,
  total,
  queryContent,
  organization,
  planId,
  week,
  gradeArr
) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.planDay}${schoolId}/${grade}?teacher=${teacherId}&type=${type}&startTime=${date}&endTime=${end}&classId=${id}&page=${page}&total=${total}&groupId=${groupId}&queryContent=${queryContent}&organization=${organization}&week=${week}&planId=${planId}&timeLst=${gradeArr}`,
    method: "get"
  });
};

//获取实习计划选择的周数的周报
export const planSelectWeekGet = (id, teacherId, end, start) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.planDay}?teacher=${teacherId}&type=周报&startTime=&endTime=&classId=${id}&page=1&total=100`,
    method: "get"
  });
};

//获取学生提交的日报
export const planSelectStudent = id => {
  console.log("idididididid", id);
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.planTaday}${id}?type=日报&page=1&total=100`,
    method: "get"
  });
};

//获取学生提交的周报
export const SelectStudentWeek = id => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.planTaday}${id}?type=周报&page=1&total=100`,
    method: "get"
  });
};

//修改多人日志
export const changeReport = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.changeDaily}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//安全管理(查询多人)
export const getStudentSafe = (
  classIds,
  groupId,
  date,
  search,
  page,
  total,
  status
) => {
  return requests({
    method: "get",
    url: `${baseURL}/${resourceEnv}/${apiUrl.studentSafeGet}?classIds=${classIds}&groupId=${groupId}&date=${date}&queryContent=${search}&page=${page}&total=${total}&status=${status}`
  });
};

//获取计划下的班级
export const getplanClass = (
  schoolId,
  grade,
  teacherId,
  page,
  total,
  organization
) => {
  var str = "";
  if (typeof organization != "undefined") {
    str = organization;
  }
  var isid = teacherId ? teacherId : "";
  return requests({
    method: "get",
    url: `${baseURL}/${resourceEnv}/${apiUrl.planClassGet}${schoolId}/${grade}?teacher=${isid}&organization=${str}&page=${page}&total=${total}`
  });
};

//查询请假信息
export const getAskforleave = (
  schoolId,
  grade,
  groupId,
  classId,
  page,
  total,
  queryContent,
  organization
) => {
  return requests({
    method: "get",
    url: `${baseURL}/${resourceEnv}/${apiUrl.AskforleaveGet}${schoolId}/${grade}?groupId=${groupId}&classId=${classId}&page=${page}&total=${total}&queryContent=${queryContent}&organization=${organization}`
  });
};

//查询签到信息
export const getClockin = (
  schoolId,
  grade,
  groupId,
  classId,
  teacherId,
  date,
  queryContent,
  organization
) => {
  return requests({
    method: "get",
    url: `${baseURL}/${resourceEnv}/${apiUrl.clockinGet}${schoolId}/${grade}?teacher=${teacherId}&date=${date}&groupId=${groupId}&classId=${classId}&queryContent=${queryContent}&organization=${organization}`
  });
};

//查询实习分析
export const getCheck = (
  schoolId,
  grade,
  groupId,
  classId,
  teacherId,
  page,
  total,
  queryContent,
  organization
) => {
  return requests({
    method: "get",
    url: `${baseURL}/${resourceEnv}/${apiUrl.checkGet}${schoolId}/${grade}?groupId=${groupId}&classId=${classId}&teacher=${teacherId}&page=${page}&total=${total}&queryContent=${queryContent}&organization=${organization}`
  });
};

//查询收藏
export const getStpreup = (
  schoolId,
  grade,
  teacherId,
  groupId,
  classId,
  type,
  page,
  total,
  queryContent,
  organization
) => {
  return requests({
    method: "get",
    url: `${baseURL}/${resourceEnv}/${apiUrl.stpreupGet}${schoolId}/${grade}/${teacherId}?groupId=${groupId}&classId=${classId}&type=${type}&origin=0&page=${page}&total=${total}&queryContent=${queryContent}&organization=${organization}`
  });
};

//收藏
export const postStpreup = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.stpreupPost}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//取消收藏
export const deleteStpreup = obj => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.stpreupDelete}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//发布安全帖子信息
export const addPosts = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.addPostsPost}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//查询安全帖子信息
export const getPosts = (schoolId, grade, page, total) => {
  return requests({
    method: "get",
    url: `${baseURL}/${resourceEnv}/${apiUrl.PostsGet}${schoolId}/${grade}?total=${total}&page=${page}`
  });
};

//删除安全帖子信息
export const deletePosts = ids => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.PostsDelete}?ids=${ids}`
  });
};

//PostsPut
export const putPosts = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.PostsPut}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//查询签到异常
export const signGet = (
  schoolId,
  grade,
  groupId,
  classIds,
  total,
  page,
  queryContent,
  organization,
  gradeArr
) => {
  return requests({
    method: "get",
    url: `${baseURL}/${resourceEnv}/${apiUrl.getSign}${schoolId}/${grade}?groupId=${groupId}&classIds=${classIds}&total=${total}&page=${page}&queryContent=${queryContent}&organization=${organization}&timeLst=${gradeArr}`
  });
};
// export const signGet = (schoolId,grade,groupId,classIds,queryContent,organization,gradeArr)=>{
//   return requests({method: "get",url: `${baseURL}/${resourceEnv}/${apiUrl.getSign}${schoolId}/${grade}?groupId=${groupId}&classIds=${classIds}&queryContent=${queryContent}&organization=${organization}&timeLst=${gradeArr}`})
// }

//查询查询电子档案
export const archivesGet = (
  schoolId,
  grade,
  classId,
  page,
  total,
  queryContent,
  organization
) => {
  return requests({
    method: "get",
    url: `${baseURL}/${resourceEnv}/${apiUrl.getArchives}${schoolId}/${grade}?classId=${classId}&total=${total}&page=${page}&queryContent=${queryContent}&organization=${organization}`
  });
};

//下载电子档案
export const archivesDownload = (
  schoolId,
  grade,
  classId,
  page,
  total,
  organization,
  obj
) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getArchives}${schoolId}/${grade}?classId=${classId}&total=${total}&page=${page}&organization=${organization}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    data: JSON.stringify(obj)
  });
};

//导入班级
export const pushClassFile = data => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.classFilePush}`,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: data
  });
};

//导入学生
export const pushStudentFile = data => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.studentImportPost}`,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data: data
  });
};

//新增安全信息
export const safeInfoPost = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.postSafeInfo}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};
//删除安全信息
export const SafeInfoDelete = obj => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.deleteSafeInfo}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};
//查询安全信息
export const safeInfoGet = (schoolId, grade) => {
  return requests({
    method: "get",
    url: `${baseURL}/${resourceEnv}/${apiUrl.getSafeInfo}${schoolId}/${grade}`
  });
};

//获取学校背景图
export const schoolBgdGet = id => {
  return requests({
    method: "get",
    url: `${baseURL}/${resourceEnv}/${apiUrl.getSchoolBgd}${id}`
  });
};

//导入题目
export const KaoshiFile = data => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.KaoshiFile}`,
    headers: { "Content-Type": "application/json" },
    data: data
  });
};

//保存组织
export const postOrganization = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.organizationPost}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//查看所有模块
export const getModule = (schooId, grade) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.moduleGet}${schooId}/${grade}`,
    method: "get"
  });
};

//新增修改角色
export const postRoles = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.rolesPost}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//查询角色
export const getRoles = (id, grade, page, total) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.rolesGet}${id}/${grade}?page=${page}&total=${total}`,
    method: "get"
  });
};

//添加修改班级
export const postClass = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.classPost}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//删除班级
export const deleteClass = obj => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.classDelete}`,
    headers: { "Content-Type": "application/json" },
    data: obj
  });
};

//获取班级的学生
export const getStudent = (id, queryContent) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.studentGet}${id}?queryContent=${queryContent}`,
    method: "get"
  });
};

//新增修改学生
export const postStudent = (obj, ib_isVip) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.studentPost}?vip=${ib_isVip}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//删除学生
export const deleteStudent = obj => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.studentDelete}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//新增学校管理员
export const postSchoolAdmin = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.schoolAdminPost}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//修改学校管理员
export const putSchoolPost = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.schoolPostPut}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//内部修改学校管理员
export const putSchoolPost2 = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.schoolPostPut2}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//查询学校和管理员账号信息
export const getSchoolAdmin = () => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.schoolAdminGet}`,
    method: "get"
  });
};

//删除学校管理员账号
export const deleteSchoolAdmin = (id, schoolId) => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.schoolAdminDelete}${id}/${schoolId}`,
    headers: { "Content-Type": "application/json" }
  });
};

//管理员账号登录
export const postLoginAdmin = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.loginAdminPost}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//新增协议
export const ArchivesPost = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.postArchives}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//查询协议
export const archivesWriteGet = (schoolId, grade, queryContent) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getArchivesWrite}${schoolId}/${grade}?page=1&total=100&queryContent=${queryContent}`,
    method: "get"
  });
};

//删除协议
export const archivesDelete = id => {
  return requests({
    method: "DELETE",
    url: `${baseURL}/${resourceEnv}/${apiUrl.deleteArchives}${id}`,
    headers: { "Content-Type": "application/json" }
  });
};

//查看试题
export const kaoshiGet = (schoolId, grade) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getKaoshi}${schoolId}/${grade}`,
    method: "get"
  });
};

//修改用户认证
export const RealUserup = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.upRealUser}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//获取当天的安全预警
export const getTadySafe = (planId, classId) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.tadySafeGet}${planId}?classId=${classId}`,
    method: "get"
  });
};

//获取二维码
export const twoCodeGet = uuid => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getTwoCode}${uuid}`,
    method: "get",
    responseType: "blob"
  });
};

//获取扫码状态
export const twoCodeStatusGet = uuid => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getTwoCodeStatus}${uuid}`,
    method: "get"
  });
};

//小程序登录
export const loginMiniAppGet = openid => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getloginMiniApp}${openid}`,
    method: "get"
  });
};

//发送用户信息
export const postsendEmail = (obj, num) => {
  console.log(obj, num);
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.sendEmailPost}${num}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//我的工作台
export const getWorkbench = (dbId, schoolId, grade, userId, gradeArr) => {
  return requests({
    url: `${baseURL}/${dbId}/teach/${schoolId}/${grade}?teacher=${userId}&timeLst=${gradeArr}`,
    method: "get"
  });
};

//我的工作台-实习计划
export const getWorkbenchPlan = (dbId, schoolId, grade, userId) => {
  return requests({
    url: `${baseURL}/${dbId}/teach/plan/${schoolId}/${grade}?teacher=${userId}`,
    method: "get"
  });
};

//账户设置
export const putAccount = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.accountPut}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//实习总结
export const getSummary = (
  schoolId,
  grade,
  groupId,
  classId,
  teacher,
  page,
  total,
  queryContent,
  organization,
  status
) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.summaryGet}${schoolId}/${grade}?groupId=${groupId}&classId=${classId}&teacher=${teacher}&page=${page}&total=${total}&queryContent=${queryContent}&organization=${organization}&status=${status}`,
    method: "get"
  });
};

//设置考核占比
export const postPercent = (schoolId, grade, params, body) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.percentPost}/${schoolId}/${grade}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: body,
    params
  });
};

//查看考核占比
export const getPractice = (schoolId, grade, organization) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.practiceGet}/${schoolId}/${grade}?organization=${organization}`,
    method: "get"
  });
};

//考核成绩
export const getResult = (classId, params) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.resultGet}/${classId}`,
    method: "get",
    params
  });
};

//导出考核评分
export const getExport = classId => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.exportGet}/${classId}`,
    method: "get",
    responseType: "blob"
  });
};

//查询考试分数
export const getkaoshifs = (obj, schoolId, grade, page, total) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.kaoshifsGet}${schoolId}/${grade}?classId=${obj.classId}&teacher=${obj.teacher}&groupId=${obj.groupId}&organization=${obj.organization}&page=${page}&total=${total}&queryContent=${obj.search}&status=${obj.status}`,
    method: "get"
  });
};

export const qingjiabhGet = (id, studentId, grade, kaishi, endTime) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.qingjiabhGet}${id}/${studentId}/${grade}?startTime=${kaishi}&endTime=${endTime}`,
    method: "put"
  });
};

//忘记密码
export const postForgotPwd = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.forgotPwdPost}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//签到异常处理
export const postDispose = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.disposePost}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//处理安全预警
export const postInform = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.informPost}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//签到异常处理记录
export const UnusualRecordGet = (
  schoolId,
  grade,
  groupId,
  classId,
  page,
  total,
  queryContent,
  organization
) => {
  console.log("classId", classId);
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.UnusualRecordGet}${schoolId}/${grade}/?&groupId=${groupId}&classIds=${classId}&page=${page}&total=${total}&queryContent=${queryContent}&organization=${organization}`,
    method: "get"
  });
};

//学校试用申请
export const applySchoolPost = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.applySchool}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//查看学校试用申请
export const getApplySchool = () => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.applySchoolGet}`,
    method: "get"
  });
};

//删除学校试用申请
export const deleteApplySchool = (id, schoolId) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.applySchoolDelete}${id}/${schoolId}`,
    method: "delete"
  });
};

//导出试用申请
export const exportApplySchool = () => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.applySchoolExport}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    responseType: "blob"
  });
};

//绑定实习计划
export const putUserPlan = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.userPlanPut}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//提升用户权限
export const promoteUserPut = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.putPromoteUser}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//导出异常处理记录
export const GetDispose = (schoolId, grade, groupId, classId, organization) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.disposeGet}${schoolId}/${grade}?groupId=${groupId}&classIds=${classId}&organization=${organization}`,
    responseType: "blob",
    requests: "blob",
    method: "get"
  });
};

//导出实习分析
export const getAnalysis = params => {
  return requests({
    url: `${baseURL}/${resourceEnv}/position/exportProcess`,
    responseType: "blob",
    method: "get",
    params,
    paramsSerializer(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};

//学校用户列表
export const Schoollist = (page, total, search, _, SchoolId, name) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.Schoollist}/${SchoolId}?page=${page}&total=${total}&queryContent=${search}&name=${name}&grade=${grade}`,
    method: "get"
  });
};
//查询所有学生
export const getStudentlist = (page, total, search, _, SchoolId, name) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.studentlistGet}/${SchoolId}?page=${page}&total=${total}&queryContent=${search}&name=${name}`,
    method: "get"
  });
};

//实习过程插入
export const putProcess = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.processPut}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//查询实习过程
export const getProcess = (
  schoolId,
  grade,
  groupId,
  classId,
  teacher,
  page,
  total,
  queryContent,
  organization,
  phone,
  stuid
) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.processGet}${schoolId}/${grade}?groupId=${groupId}&classId=${classId}&teacher=${teacher}&page=${page}&total=${total}&queryContent=${queryContent}&organization=${organization}&phone=${phone}&stuid=${stuid}`,
    method: "get"
  });
};

//下载实习总结 Content-Type
export const postSummaryDown = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.summaryDownPost}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    data: JSON.stringify(obj)
  });
};

//下载周日报收藏
export const postCollectDown = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.collectDownPost}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    data: JSON.stringify(obj)
  });
};

//实习过程导出
export const postProcess = (schoolId, grade, obj) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.processPost}${schoolId}/${grade}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    data: JSON.stringify(obj)
  });
};
//url: `${baseURL}/${resourceEnv}/position/exportMyStudent`,
// url: `http://localhost:8080/${resourceEnv}/position/exportMyStudent`,



export const exportMyStudent2 = (classid, type) => {
  return requests({
    url: `http://localhost:8080/${resourceEnv}/position/exportMyStudent/${classid}/${type}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    responseType: "blob"
   
  });
};

export const exportMyStudent = params => {

  return requests({
    url: `${baseURL}/${resourceEnv}/position/exportMyStudent`,
    method: "get",
    responseType: "blob",
    params,
    paramsSerializer(params) {
      return Object.keys(params)
        .map(
          key => encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
        )
        .join("&");
    }
  });
};
export const exportAllStudent = (grade) => {
 
  return requests({
    url: `${baseURL}/${resourceEnv}/position/exportAllStudent/${grade}`,
    method: "get",
    responseType: "blob"
  });
};




export const exportSummary = params => {
  return requests({
    url: `${baseURL}/${resourceEnv}/position/exportSummary`,
    method: "get",
    responseType: "blob",
    params,
    paramsSerializer(params) {
      return Object.keys(params)
        .map(
          key => encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
        )
        .join("&");
    }
  });
};



export const exportClassType = params => {
  return requests({
    url: `${baseURL}/${resourceEnv}/position/exportClassType`,
    method: "get",
    responseType: "blob",
    params,
    paramsSerializer(params) {
      return Object.keys(params)
        .map(
          key => encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
        )
        .join("&");
    }
  });
};




//推送公众号
export const gongzhonghaofs = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.gongzhonghaofs}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: obj
  });
};

//获取二维码（公司）
export const getqrcompany = companyId => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getqrcompany}${companyId}`,
    method: "get",
    responseType: "blob",
    requests: "blob"
  });
};
//获取二维码（学生）
export const qrstudentGet = stuId => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getStudentToCode}${stuId}`,
    method: "get",
    responseType: "blob"
  });
};

//实习指导
export const getGuidance = teacherId => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.guidanceGet}${teacherId}`,
    method: "get"
  });
};
//实习巡查
export const getPatrol = (schoolId, grade) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.patrolGet}${schoolId}/${grade}`,
    method: "get"
  });
};
//查询所有学校
export const getSchoolList = () => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.schoolListGet}`,
    method: "get"
  });
};
//设置功能模块
export const postSchoolModular = obj => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.schoolModularPost}`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//更换用户头像
export const userJpgUpdata = obj => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.updataUserJpg}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//添加年度
export const gradeAdd = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.addGrade}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//数字化大屏
export const shuzihuadp = (schoolId, grade) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.shuzihuadp}?schoolId=${schoolId}&grade=${grade}`,
    method: "get"
  });
};

//删除年度
export const deleteGrade = id => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.gradeDelete}${id}`,
    method: "delete"
  });
};

//打卡
export const clokinGet = (
  time,
  classId,
  groupId,
  search,
  gradeArr,
  page,
  total
) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getClokin}?classid=${classId}&time=${time}&groupid=${groupId}&queryContent=${search}&page=${page}&total=${total}&timeLst=${gradeArr}`,
    method: "get"
  });
};

//增加反馈
export const feedbackAdd = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.addFeedback}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};
//获取反馈
export const feedbackGet = (page, total) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getFeedback}?page=${page}&total=${total}`,
    method: "get"
  });
};
//删除反馈
export const FeedbackDelete = obj => {
  console.log(obj);
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.deleteFeedback}`,
    method: "delete",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//修改节假日
export const GradeUpdate = grade => {
  return requests({
    method: "put",
    url: `${baseURL}/${resourceEnv}/${apiUrl.GradeUpdate}?grade=${grade}`
  });
};

//新增学校数据库配置
export const addDatabase = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.addDatabase}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//查看学校数据库配置
export const getDatabase = () => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getDatabase}`,
    method: "get"
  });
};

//删除学校数据库配置
export const deleteDatabase = id => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.deleteDatabase}${id}`,
    method: "delete"
  });
};

//向学校中添加年度
export const addSchoolGrade = obj => {
  return requests({
    method: "post",
    url: `${baseURL}/${resourceEnv}/${apiUrl.addSchoolGrade}`,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(obj)
  });
};

//获取近七天打卡状态
export const getTimeslotClick = (
  classid,
  groupid,
  startTime,
  endTime,
  pageNum,
  pageSize,
  name
) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getTimeslotClick}?classid=${classid}&startTime=${startTime}&endTime=${endTime}&pageNum=${pageNum}&pageSize=${pageSize}&name=${name}&groupid=${groupid}`,
    method: "get"
  });
};

//获取近七天周日报状态
export const getDailyLog = (
  classid,
  groupid,
  startTime,
  endTime,
  pageNum,
  pageSize,
  name,
  type
) => {
  return requests({
    url: `${
      type == "1" ? apiUrl.getDailyLog : apiUrl.getWeekLog
    }?classid=${classid}&startTime=${startTime}&endTime=${endTime}&pageNum=${pageNum}&pageSize=${pageSize}&name=${name}&groupid=${groupid}`,
    method: "get"
  });
};
// 获取档案管理数据
export const getFiles = (classid, pageNum, pageSize) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getFiles}`,
    method: "get",
    params: {
      classid,
      pageNum,
      pageSize
    }
  });
};
// 获取实习去向管理数据
export const getPracticePosition = (classid, pageNum, pageSize, type) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.stuInfo}`,
    method: "get",
    params: {
      classid,
      pageNum,
      pageSize,
      type
    }
  });
};

export const exportClass = (classid, type, classType) => {

  return requests({
    url: `${baseURL}/${resourceEnv}/position/exportDestination`,
    method: "get",
    params: {
      classid,
      type,
      classType
    },
    responseType: "blob"
  });
};

//模糊查询获取数据（天眼查api）
export const getSearchData = word => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getseachData}`,
    method: "get",
    params: {
      word,
      pageSize: 20,
      pageNum: 1
    }
  });
};

// 获取所有虚拟实验班名字的数据
export const getAllClass = schoolid => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getAllClass}/${schoolid}`,
    method: "get"
  });
};

//角色管理用户导入
export const exportUser = data => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.exportUser}`,
    method: "post",
    data: data
  });
};

//查询教师周报
export const getTeacherLog = teacherid => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getTeacherLog}/${teacherid}`,
    method: "get"
  });
};

//下载老师周报
export const downloadTeacherLog = teacherid => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.downloadTeacher}/${teacherid}`,
    method: "get",
    responseType: "blob"
  });
};

//查询申请岗位的学生新接口
export const getListNew = (
  classid,
  type,
  name,
  status,
  pageNum,
  pageSize,
  isChange
) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.applyGetStudentNew}`,
    method: "get",
    params: {
      classid,
      type,
      name,
      status,
      pageNum,
      pageSize,
      isChange
    }
  });
};
export const exportApply = status => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.exportApply}`,
    method: "get",
    responseType: "blob",
    params: { status }
  });
};

export const exportUninvite = () => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.exportUninvite}`,
    method: "get",
    responseType: "blob"
  });
};

export const getUnlnvitePosition = (classid, name, pageNum, pageSize) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getUnlnvitePosition}`,
    method: "get",
    params: {
      classid,
      name,
      pageNum,
      pageSize
    }
  });
};

// 通过老师获取学生信息
export const getModify = (classid, name, pageNum, pageSize) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.getModify}`,
    params: {
      classid,
      name,
      pageNum,
      pageSize
    }
  });
};

//打卡管理时间段导出文件
export const exportSign2 = (classid, startTime, endTime) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.exportSign2}`,
    method: "get",
    params: {
      classid,
      startTime,
      endTime
    },
    responseType: "blob"
  });
};

//打卡管理导出文件
export const exportSign = (classid, time, type) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.exportSign}`,
    method: "get",
    params: {
      classid,
      time,
      type
    },
    responseType: "blob"
  });
};

//班级管理搜索通过学生姓名、学号、电话号码
export const searchStudent = (stuName, phone, stuid) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.searchStudent}`,
    method: "GET",
    params: {
      stuName,
      phone,
      stuid
    }
  });
};

export const cancelSummary = (id, img_id) => {
  return requests({
    url: `${baseURL}/${resourceEnv}/${apiUrl.cancelSummary}`,
    method: "PUT",
    data: { id: id, img_id: img_id }
  });
};

export const getClassStudent = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getClassStudent}`, {
    params: params
  });
};

export const removeOpenid = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.removeOpenid}`, {
    params: params
  });
};




export const getTeacherClass = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getTeacherClass}`, {
    params: params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};

export const quitClass = (id, params) => {
  return requests.put(
    `${baseURL}/${resourceEnv}/${apiUrl.quitClass}/${id}`,
    null,
    {
      params: params
    }
  );
};
export const getAdminStudent = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getAdminStudent}`, {
    params: params
  });
};
export const updateApply = body => {
 
  return requests.post(`${baseURL}/${resourceEnv}/${apiUrl.updateApply}`, body);
};
export const getApply = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getApply}`, {
    params: params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const changeClassStatus = params => {
  return requests.put(
    `${baseURL}/${resourceEnv}/${apiUrl.changeClassStatus}`,
    null,
    {
      params: params
    }
  );
};
export const getClassId = id => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getClassId}${id}`);
};
export const getAllStudent = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getAllStudent}`, {
    params: params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const getSign = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getSign1}`, {
    params: params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const getLeave = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getLeave}`, {
    params: params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const refuseLeave = params => {
  return requests.put(`${baseURL}/${resourceEnv}/${apiUrl.refuseLeave}`, null, {
    params: params
  });
};
export const getSignRange = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getSignRange}`, {
    params
  });
};
export const process = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.process}`, {
    params: params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const destination = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.destination}`, {
    params: params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const getLog = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getLog}`, {
    params: params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const getWeekLog = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getWeekLog}`, {
    params: params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const refuseLog = (id, params) => {
  return requests.put(
    `${baseURL}/${resourceEnv}/${apiUrl.refuseLog}/${id}`,
    null,
    {
      params: params
    }
  );
};
export const getStudentWeekLog = (id, params) => {
  return requests.get(
    `${baseURL}/${resourceEnv}/${apiUrl.getStudentWeekLog}/${id}`,
    {
      params: params
    }
  );
};
export const signAbnormal = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.signAbnormal}`, {
    params: params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const getArchives1 = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getArchives1}`, {
    params: params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const getStudentArchives = (studentid, params) => {
  return requests.get(
    `${baseURL}/${resourceEnv}/${apiUrl.getStudentArchives}/${studentid}`,
    {
      params: params
    }
  );
};
export const getGuidance1 = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getGuidance}`, {
    params: params
  });
};
export const getPatrol1 = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getPatrol}`, {
    params: params
  });
};
export const getDisperse = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.getDisperse}`, {
    params: params
  });
};
export const updateDisperseStatus = (id, status, reason) => {
  return requests.put(
    `${baseURL}/${resourceEnv}/${apiUrl.updateDisperseStatus}/${id}`,
    void 0,
    {
      params: { status, reason }
    }
  );
};
export const deleteDisperseStatus = (id, images) => {
  return requests.delete(
    `${baseURL}/${resourceEnv}/position/deleteDisperseStatus/${id}`,
    {
      params: { images },
      paramsSerializer: function(params) {
        return Object.keys(params)
          .map(function(key) {
            return (
              encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
            );
          })
          .join("&");
      }
    }
  );
};
export const exportDisperse = params => {
  return requests.get(`${baseURL}/${resourceEnv}/${apiUrl.exportDisperse}`, {
    params,
    responseType: "blob"
  });
};
export const getChangePhone = params => {
  return requests.get(`${baseURL}/${resourceEnv}/position/getChangePhone`, {
    params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const deleteChangePhone = params => {
  return requests.delete(
    `${baseURL}/${resourceEnv}/position/deleteChangePhone`,
    {
      params
    }
  );
};
export const updateChangePhone = params => {
  return requests.put(
    `${baseURL}/${resourceEnv}/position/updateChangePhone`,
    void 0,
    {
      params
    }
  );
};
export const eqPhone = phone => {
  return requests.get(`${baseURL}/${resourceEnv}/user/eqPhone/${phone}`);
};
export const getMonthLog = params => {
  return requests.get(`${baseURL}/${resourceEnv}/position/getMonthLog`, {
    params,
    paramsSerializer: function(params) {
      return Object.keys(params)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
          );
        })
        .join("&");
    }
  });
};
export const getStudentMonthLog = studentid => {
  return requests.get(
    `${baseURL}/${resourceEnv}/position/getStudentMonthLog/${studentid}`
  );
};


export const addPaln = body => {
  return requests.post(
    `${baseURL}/${resourceEnv}/position/addPaln`,
    body
  );
};

export const getFirstClass = params => {
  return requests.get(`${baseURL}/${resourceEnv}/position/getFirstClass`, {
    params
  });
};

export const getPlan = params => {
  return requests.get(`${baseURL}/${resourceEnv}/position/getPlan`, {
    params
  });
};

export const deletePlan = id => {
  return requests.delete(
    `${baseURL}/${resourceEnv}/position/deletePlan/${id}`
  );
};


export const addSchoolNotice = body => {
  return requests.post(
    `${baseURL}/${resourceEnv}/position/addSchoolNotice`,
    body
  );
};
export const getSchoolNotice = params => {
  return requests.get(`${baseURL}/${resourceEnv}/position/getSchoolNotice`, {
    params
  });
};

export const getStudentAnalysis = params => {

  return requests.get(`${baseURL}/${resourceEnv}/position/getStudentAnalysis`, {
    params
  });
};

export const getStudentActivationAnalysis = params => {

  return requests.get(`${baseURL}/${resourceEnv}/position/getStudentActivationAnalysis`, {
    params
  });
};


export const getStudentTypeAnalysis = params => {

  return requests.get(`${baseURL}/${resourceEnv}/position/getStudentTypeAnalysis`, {
    params
  });
};

export const getuser = params => {

  return requests.get(`${baseURL}/${resourceEnv}/position/getuser`, {
    params
  });
};

export const getAllCompany = params => {

  return requests.get(`${baseURL}/${resourceEnv}/position/getAllCompany`, {
    params
  });
};

export const getAllLog = params => {

  return requests.get(`${baseURL}/${resourceEnv}/position/getAllLog`, {
    params
  });
};

export const getlogin = params => {

  return requests.get(`${baseURL}/${resourceEnv}/position/getlogin`, {
    params
  });
};


export const getlogin2 = params => {

  return requests.get(`${baseURL}/${resourceEnv}/position/getlogin2`, {
    params
  });
};


export const getlogin3 = params => {

  return requests.get(`${baseURL}/${resourceEnv}/position/getlogin3`, {
    params
  });
};

export const deleteSchoolNotice = id => {
  return requests.delete(
    `${baseURL}/${resourceEnv}/position/deleteSchoolNotice/${id}`
  );
};
export const updateWorkStatus = params => {
  return requests.put(
    `${baseURL}/${resourceEnv}/position/updateWorkStatus`,
    void 0,
    { params }
  );
};
export const updateWorkScore = params => {
  return requests.put(
    `${baseURL}/${resourceEnv}/position/updateWorkScore`,
    void 0,
    { params }
  );
};
export const updateFinalScore = params => {
  return requests.put(
    `${baseURL}/${resourceEnv}/position/updateFinalScore`,
    void 0,
    { params }
  );
};
export const exportPatrol = id => {
  return requests.get(`${baseURL}/${resourceEnv}/position/exportPatrol/${id}`, {
    responseType: "blob"
  });
};
export const exportArchives = id => {
  return requests.get(
    `${baseURL}/${resourceEnv}/position/exportArchives/${id}`,
    { responseType: "blob" }
  );
};
export const changeClass = (studentid, params) => {
  return requests.put(
    `${baseURL}/${resourceEnv}/position/changeClass/${studentid}`,
    void 0,
    { params }
  );
};
export const updateLogStatus = params => {
  return requests.put(
    `${baseURL}/${resourceEnv}/position/updateLogStatus`,
    void 0,
    { params }
  );
};



// WEBPACK FOOTER //
// ./src/api/index.js